import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { AppserviceService } from './service/appservice.service';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent  implements OnInit{
  public appPages = [
    { title: 'الرئيسية', url: '/welcome', icon: 'home-outline' },
    { title: 'تواصل معنا ', url: '/contact', icon: 'mail-open-outline' },
    { title: 'من نحن', url: '/about', icon: 'information-circle-outline' },
    { title: ' تسجيل الدخول ', url: '/login', icon: 'car-sport-outline' },

  ];
  constructor(
    public afauth: AngularFireAuth,
    private ser: AppserviceService,
    public router: Router
  ) {
    window.document.dir = 'rtl';
    this.afauth.onAuthStateChanged( async (r) => {
      if (r) {
        if (r.email) {
          this.ser.connected = true ;
          this.appPages = [
            { title: 'الرئيسية', url: '/welcome', icon: 'home-outline' },
            { title: 'تواصل معنا ', url: '/contact', icon: 'mail-open-outline' },
            { title: 'من نحن', url: '/about', icon: 'information-circle-outline' },
            { title: ' قائمة التسجيلات ', url: '/list', icon: 'car-sport-outline' },
          ];
          this.ser.loadBookings();
          this.router.navigateByUrl('/list');

        } else if (r.isAnonymous ) {
          this.ser.connected = false ;
          this.appPages = [
            { title: 'الرئيسية', url: '/welcome', icon: 'home-outline' },
            { title: 'تواصل معنا ', url: '/contact', icon: 'mail-open-outline' },
            { title: 'من نحن', url: '/about', icon: 'information-circle-outline' },
            { title: ' تسجيل الدخول ', url: '/login', icon: 'car-sport-outline' },
          ];

        }
      } else {
        this.ser.connected = false ;
        this.appPages = [
          { title: 'الرئيسية', url: '/welcome', icon: 'home-outline' },
          { title: 'تواصل معنا ', url: '/contact', icon: 'mail-open-outline' },
          { title: 'من نحن', url: '/about', icon: 'information-circle-outline' },
          { title: ' تسجيل الدخول ', url: '/login', icon: 'car-sport-outline' },
        ];

      }
    });

  }

  ngOnInit(): void {
    this.afauth.signInAnonymously().catch(e => console.log(e));

  }
}
